// Identique à buildVehiculeOptionLabel dans backend/controllers/utils.js.
// Les trois emplacements restent présents, même vides : « Marque - Plaque - Châssis ».
export function buildVehiculeOptionLabel(vehicule) {
  if (!vehicule || typeof vehicule !== 'object') return '';
  return [vehicule.brand, vehicule.plateNumber, vehicule.chassisNumber]
    .map((part) => (part == null ? '' : String(part)))
    .join(' - ');
}
